import { render, staticRenderFns } from "./SectionRoster.vue?vue&type=template&id=0f33f9d6&scoped=true"
import script from "./SectionRoster.vue?vue&type=script&lang=js"
export * from "./SectionRoster.vue?vue&type=script&lang=js"
import style0 from "./SectionRoster.vue?vue&type=style&index=0&id=0f33f9d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f33f9d6",
  null
  
)

export default component.exports